export default function Services() {
  return (
    <div className="p-6 bg-black text-white min-h-screen">
      Our services.
    </div>
  );
}